import {
  canShowCameraUnitScan,
  canShowOnvifScan,
} from "../../../utils/onvifScanAccess";
/* eslint-disable react-hooks/exhaustive-deps */
import * as React from "react";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableRow from "@mui/material/TableRow";
import TablePagination from "@mui/material/TablePagination";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import { ThemeProvider } from "@mui/material/styles";
import { theme } from "../../../utils/themeCreator";
import { Button } from "@mui/material";
import { checkedCircleIcon } from "../../../common/checkedCircleIcon";
import { cancelIconRed } from "../../../common/cancelIconRed";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";
import { CameraInfoRow } from "./CameraInfoRow";
import { useCameraStatusPolling } from "./SiteAboutPageUtils/cameraStatusPolling";
import Checkbox from "@mui/material/Checkbox";
import { DuplicateCameraSiteButton } from "./DuplicateCameraButton";
import { ActivateButton } from "./ActivateButton";
import { DeactivateButton } from "./DeactivateButton";
import { DeleteCameraButton } from "./DeleteCameraButton";
import {
  MilestoneMotionButton,
  showMilestoneMotionButton,
} from "./MilestoneMotionButton";
import { BulkMotionButton } from "./BulkMotionButton";
import { BulkEmailRecipientsButton } from "./BulkEmailRecipientsButton";
import { MotionOverrideMarker } from "./MotionOverrideMarker";
import {
  motionSettingVisible,
  overrideMayMatter,
} from "../../EditCamera/cameraMotionOverride";
import useWindowDimensions from "../../../common/useWindowDimensions";
import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";
import { getAndSaveSiteImages } from "./SiteAboutPageUtils/getAndSaveSiteImages";
import { downloadCameraOverview } from "./SiteAboutPageUtils/downloadCameraOverview";
import WarningIcon from "@mui/icons-material/Warning";
import CancelIcon from "@mui/icons-material/Cancel";
import ErrorIcon from "@mui/icons-material/Error";
import {
  AlertState,
  SiteCameras,
  SiteCamerasResult,
} from "./SiteAboutPageUtils/siteAboutInterfaces";
import { NavigateFunction, Link } from "react-router-dom";
import { EnhancedTableProps } from "./SiteCameras";
import { EnhancedCameraTableHead } from "./EnhancedCameraTableHead";
import { AlertData, Order } from "../../Alerts/AlertsUtils/alertsInterfaces";
import {
  stableSort,
  getComparator,
} from "../../Alerts/AlertsUtils/alertsTableFunctions";
import SyncIcon from "@mui/icons-material/Sync";
import { handleRefreshCameras } from "./SiteAboutPageUtils/handleRefreshCameras";
import { createOptimalSettingsIcon } from "./SiteAboutPageUtils/createOptimalSettingsIcon";
import { useSiteAboutStore } from "./siteAboutStore/siteAboutStore";
import { AutoPatrolScheduleTabs } from "./AutoPatrolScheduleTabs";
import { BulkUpdateProductsDialog } from "./BulkUpdateProductsDialog";
import { useFeatureFlag } from "../../../../hooks/useFeatureFlag";
import { TalkDownButton } from "../../../common/TalkDown/TalkDownButton";

type Dispatcher<S> = React.Dispatch<React.SetStateAction<S>>;

export const CamerasTable = ({
  navigate,
  EnhancedTableHead,
  siteCameras,
  page,
  rowsPerPage,
  isSelected,
  setPage,
  setRowsPerPage,
  handleSelectAllClick,
  handleSingleCheckboxClick,
  selected,
  setSiteCameras,
  setDeleteDialogOpen,
  setAlertState,
  setSelected,
  setSyncNeeded,
  setBackdropLoadingScreenOn,
  setNoAutoAddCamerasDialogOpen,
  siteInfo,
  setSiteInfo,
  setSiteSchedules,
  setActiveTab,
  setDataLoaded,
  setAllSiteSchedules,
  setVmsVariables,
  setArmedStatus,
  setAiLinkSite,
  setSiteDeployed,
  setCamerasNotDeployed,
  setToolTipTitle,
  setConfigureMotion,
  setPatchObject,
  setArmButtonDisabled,
  setRecordingServerData,
  setRecordingServerPatchObject,
  setRecordingServerVisible,
  setHealthCheckData,
  setCamerasRefreshing,
  permissions,
  setWebhooksInfo,
  setWebhooksPatchObject,
  siteSchedules,
}: {
  navigate: NavigateFunction;
  EnhancedTableHead: (props: EnhancedTableProps) => JSX.Element;
  siteCameras: SiteCameras;
  page: number;
  rowsPerPage: number;
  isSelected: (id: string) => boolean;
  setPage: Dispatcher<number>;
  setRowsPerPage: Dispatcher<number>;
  handleSelectAllClick: (event: React.ChangeEvent<HTMLInputElement>) => void;
  handleSingleCheckboxClick: (
    event: React.MouseEvent<unknown>,
    id: string
  ) => void;
  selected: readonly string[];
  setSiteCameras: Dispatcher<SiteCameras>;
  setDeleteDialogOpen: Dispatcher<boolean>;
  setAlertState: Dispatcher<AlertState>;
  setSelected: Dispatcher<readonly string[]>;
  setSyncNeeded: Dispatcher<boolean>;
  setBackdropLoadingScreenOn: Dispatcher<boolean>;
  setNoAutoAddCamerasDialogOpen: Dispatcher<boolean>;
  siteInfo: any;
  setSiteInfo: any;
  setSiteSchedules: any;
  setActiveTab: any;
  setDataLoaded: any;
  setAllSiteSchedules: any;
  setVmsVariables: any;
  setArmedStatus: any;
  setAiLinkSite: any;
  setSiteDeployed: any;
  setCamerasNotDeployed: any;
  setToolTipTitle: any;
  setConfigureMotion: any;
  setPatchObject: any;
  setArmButtonDisabled: any;
  setRecordingServerData: any;
  setRecordingServerPatchObject: any;
  setRecordingServerVisible: Dispatcher<boolean>;
  setHealthCheckData: any;
  setCamerasRefreshing: Dispatcher<boolean>;
  permissions: any;
  setWebhooksInfo: any;
  setWebhooksPatchObject: any;
  siteSchedules: any;
}) => {
  const [expandedObject, setExpandedObject] = React.useState({});

  const { width } = useWindowDimensions();

  const [srcImages, setSrcImages] = React.useState({});

  const [order, setOrder] = React.useState<Order>("asc");
  const [orderBy, setOrderBy] = React.useState("formatted_date");

  const [renderedRows, setRenderedRows] = React.useState(siteCameras.results);
  // Keep camera status fresh until every camera has reported (ENG-2853).
  useCameraStatusPolling(
    React.useMemo(
      () => siteCameras.results.map((camera) => Number(camera.id)),
      [siteCameras.results]
    )
  );

  const [allExpanded, setAllExpanded] = React.useState(false);

  const [count, setCount] = React.useState(0);

  const [bulkUpdateDialogOpen, setBulkUpdateDialogOpen] = React.useState(false);
  const { isFeatureEnabled } = useFeatureFlag();
  const showBulkUpdating = isFeatureEnabled("showBulkUpdating", false);

  const {
    hideUseMotion,
    activeCameraProducts,
    activeCameraProductsLoading,
    prefetchBulkDialogActiveCameraProducts,
  } = useSiteAboutStore();

  const hideIgnoreZonesColumn = false;

  // The camera list's use_motion is a label: "Actuate"/"Milestone" when the
  // camera's resolved value is on, "" or "Native Camera" when it's off.
  const showBulkMotion = motionSettingVisible({
    integrationTypeName: siteInfo?.integration_type_name,
    siteUseMotion: siteInfo?.use_motion,
    cameraUsesMotion: siteCameras.results.some(
      (camera) =>
        camera.use_motion === true ||
        camera.use_motion === "Actuate" ||
        camera.use_motion === "Milestone"
    ),
    overrideMatters: siteCameras.results.some((camera) =>
      overrideMayMatter({
        integrationTypeName: siteInfo?.integration_type_name,
        override: camera.use_motion_override,
      })
    ),
  });

  const { handleFilterCameras, selectedAutoPatrolScheduleIndex } =
    useSiteAboutStore();

  const selectedCameras = React.useMemo(
    () =>
      siteCameras.results
        .filter((camera) => selected.includes(String(camera.id)))
        .map((camera) => ({
          id: camera.id,
          camera_name: camera.camera_name,
        })),
    [siteCameras.results, selected]
  );

  const openBulkUpdateDialog = () => {
    const selectedCameraIds = selected.map(Number);
    if (selectedCameraIds.length === 0) return;
    setBulkUpdateDialogOpen(true);
    void prefetchBulkDialogActiveCameraProducts(
      navigate,
      siteInfo?.id,
      selectedCameraIds
    );
  };

  const handleRequestSort = (
    event: React.MouseEvent<unknown>,
    property: any
  ) => {
    const isAsc = orderBy === property && order === "asc";
    setOrder(isAsc ? "desc" : "asc");
    setOrderBy(property);
  };

  const saveExpandedObject = (objectId: string | number) => {
    setExpandedObject((previousState: { [key: string]: boolean }) => ({
      ...previousState,
      [objectId]: !previousState[objectId],
    }));
  };

  const saveExpandedObjectAllTrue = () => {
    setExpandedObject((previousState: { [key: string]: boolean }) => {
      const nextState = { ...previousState };
      Object.keys(nextState).forEach((key) => {
        nextState[key] = true;
      });
      return nextState;
    });
  };

  const saveExpandedObjectAllFalse = () => {
    setExpandedObject((previousState: { [key: string]: boolean }) => {
      const nextState = { ...previousState };
      Object.keys(nextState).forEach((key) => {
        nextState[key] = false;
      });
      return nextState;
    });
  };

  const handleChangePage = (event: unknown, newPage: number) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>
  ) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  React.useEffect(() => {
    siteCameras.results.forEach((object: SiteCamerasResult) => {
      setExpandedObject((previousState: { [key: string]: boolean }) => {
        return { ...previousState, [object.id]: false };
      });
    });
  }, []);

  React.useEffect(() => {
    let filteredCameras = siteCameras.results;

    if (siteInfo.integration_type_name === "autopatrol") {
      filteredCameras = handleFilterCameras(siteCameras.results);
    }

    setCount(filteredCameras.length);
    setRenderedRows(filteredCameras);
  }, [siteCameras, expandedObject, selectedAutoPatrolScheduleIndex]);

  const cameraIdsSignature = React.useMemo(
    () =>
      siteCameras?.results?.map((c: SiteCamerasResult) => c.id).join(",") ?? "",
    [siteCameras?.results]
  );

  const siteCamerasRef = React.useRef(siteCameras);
  siteCamerasRef.current = siteCameras;

  React.useEffect(() => {
    if (!cameraIdsSignature) {
      return;
    }
    getAndSaveSiteImages(siteCamerasRef.current, setSrcImages, navigate);
  }, [cameraIdsSignature, navigate]);

  const nA = `N/A`;

  const autopatrolSite = siteInfo.integration_type_name === "autopatrol";

  const visibleRows = React.useMemo(
    () =>
      stableSort(renderedRows, getComparator(order, orderBy)).slice(
        page * rowsPerPage,
        page * rowsPerPage + rowsPerPage
      ),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [order, orderBy, page, rowsPerPage, renderedRows]
  );

  return (
    <Paper sx={{ width: "100%", overflow: "hidden" }}>
      <TableContainer>
        <div className="relative">
          <Typography
            sx={{
              fontFamily: "Mulish",
              fontWeight: "Bold",
              textIndent: "33px",
              paddingTop: "10px",
            }}
            variant="h6"
            id="tableTitle"
            component="div"
          >
            Site Cameras
            {/* {siteInfo.integration_type_name === "autopatrol" && (
              <div>
                <AutoPatrolScheduleTabs />
              </div>
            )} */}
            <div className="absolute right-9 top-[12px] flex items-center gap-3">
              {/* Download Camera Overview — per-camera settings CSV */}
              <ThemeProvider theme={theme}>
                <Button
                  type="button"
                  color="primary"
                  sx={{ fontFamily: "Mulish", textTransform: "none" }}
                  onClick={() => {
                    downloadCameraOverview(siteInfo.id).catch(() => {
                      alert(
                        "Failed to download the camera overview. Please try again."
                      );
                    });
                  }}
                >
                  Download Camera Overview
                </Button>
              </ThemeProvider>
              {/* ONVIF Scan — discovery; independent from manual Add Camera */}
              {canShowOnvifScan(
                permissions,
                siteInfo.integration_type_name
              ) && (
                <Button
                  type="button"
                  variant="contained"
                  onClick={() => {
                    localStorage.setItem("addAdditionalCamera", "true");
                    navigate(`/sites/${siteInfo.id}/onvifscan`);
                  }}
                  sx={{
                    fontFamily: "Mulish",
                    textTransform: "none",
                    backgroundColor: "#283E6D",
                    color: "#FFFFFF",
                    "&:hover": { backgroundColor: "#1f2f54" },
                  }}
                >
                  ONVIF Scan
                </Button>
              )}
              {/* Refresh camera streams — re-read existing cameras' units over
                  ONVIF and update host/port/path/login in place. Genetec direct
                  and rtsp/onvif_wireguard sites; edit permission, not add. */}
              {canShowCameraUnitScan(permissions, siteInfo) && (
                <Button
                  type="button"
                  variant="contained"
                  onClick={() => navigate(`/sites/${siteInfo.id}/unitscan`)}
                  sx={{
                    fontFamily: "Mulish",
                    textTransform: "none",
                    backgroundColor: "#283E6D",
                    color: "#FFFFFF",
                    "&:hover": { backgroundColor: "#1f2f54" },
                  }}
                >
                  Refresh camera streams
                </Button>
              )}
              {/* Add Camera — original manual add (or NVR auto-add for auto_add sites) */}
              {siteInfo.integration_type_name !== "ailink" &&
                siteInfo.integration_type_name !== "autopatrol" &&
                permissions.add_cameras && (
                  <ThemeProvider theme={theme}>
                    <Button
                      type="button"
                      color="primary"
                      onClick={() => {
                        localStorage.setItem("addAdditionalCamera", "true");
                        localStorage.setItem(
                          "clickedFromSiteAboutPage",
                          "true"
                        );
                        localStorage.setItem(
                          "navigatedFromSitesAboutPage",
                          "true"
                        );
                        if (siteInfo.auto_add) {
                          navigate("/sites/autoaddcamera");
                        } else {
                          localStorage.setItem("firstCameraAdded", "true");
                          localStorage.setItem("copyValues", "true");
                          navigate("/sites/addcamera");
                        }
                      }}
                    >
                      + Add Camera
                    </Button>
                  </ThemeProvider>
                )}
            </div>
            {siteInfo.display_refresh && (
              <div className="absolute left-[160px] top-[12px]">
                <ThemeProvider theme={theme}>
                  <Button
                    type="button"
                    color="primary"
                    onClick={() => {
                      setBackdropLoadingScreenOn(true);
                      setExpandedObject({});
                      setCamerasRefreshing(true);
                      handleRefreshCameras(
                        navigate,
                        setSiteInfo,
                        setSiteSchedules,
                        setSiteCameras,
                        setActiveTab,
                        setDataLoaded,
                        setBackdropLoadingScreenOn,
                        setAllSiteSchedules,
                        setVmsVariables,
                        setNoAutoAddCamerasDialogOpen,
                        setArmedStatus,
                        setAiLinkSite,
                        setSiteDeployed,
                        setSyncNeeded,
                        setAlertState,
                        setCamerasNotDeployed,
                        setToolTipTitle,
                        setConfigureMotion,
                        setPatchObject,
                        setArmButtonDisabled,
                        setRecordingServerData,
                        setRecordingServerPatchObject,
                        setRecordingServerVisible,
                        setHealthCheckData,
                        setCamerasRefreshing,
                        setWebhooksInfo,
                        setWebhooksPatchObject
                      );
                    }}
                  >
                    <SyncIcon fontSize="small" /> &nbsp; Refresh Camera Previews
                  </Button>
                </ThemeProvider>
              </div>
            )}
          </Typography>
        </div>
        {siteInfo.integration_type_name !== "autopatrol" && (
          <div className="pt-2">
            <span className="relative left-6">
              {permissions.add_cameras && (
                <>
                  <DuplicateCameraSiteButton
                    selected={selected}
                    setSiteCameras={setSiteCameras}
                    setAlertState={setAlertState}
                    setSelected={setSelected}
                    setSyncNeeded={setSyncNeeded}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </>
              )}
              {permissions.edit_cameras && (
                <>
                  <ActivateButton
                    selected={selected}
                    setSiteCameras={setSiteCameras}
                    setAlertState={setAlertState}
                    setSelected={setSelected}
                    setSyncNeeded={setSyncNeeded}
                    setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                  <DeactivateButton
                    selected={selected}
                    setSiteCameras={setSiteCameras}
                    setAlertState={setAlertState}
                    setSelected={setSelected}
                    setSyncNeeded={setSyncNeeded}
                    setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                    setSiteInfo={setSiteInfo}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </>
              )}
              {permissions.delete_cameras && (
                <DeleteCameraButton
                  selected={selected}
                  setDeleteDialogOpen={setDeleteDialogOpen}
                />
              )}
              &nbsp;&nbsp;&nbsp;&nbsp;
              {permissions.edit_cameras &&
                showMilestoneMotionButton(siteInfo.integration_type_name) && (
                  <>
                    <MilestoneMotionButton
                      selected={selected}
                      siteInfo={siteInfo}
                      setSiteCameras={setSiteCameras}
                      setAlertState={setAlertState}
                      setSelected={setSelected}
                      setSyncNeeded={setSyncNeeded}
                      setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                    />
                    &nbsp;&nbsp;&nbsp;&nbsp;
                  </>
                )}
              {permissions.edit_cameras && showBulkMotion && (
                <>
                  <BulkMotionButton
                    selected={selected}
                    siteCameras={siteCameras}
                    siteInfo={siteInfo}
                    setSiteCameras={setSiteCameras}
                    setSelected={setSelected}
                    setSyncNeeded={setSyncNeeded}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </>
              )}
              {permissions.edit_cameras && (
                <>
                  <BulkEmailRecipientsButton
                    siteCameras={siteCameras}
                    siteInfo={siteInfo}
                    setSiteCameras={setSiteCameras}
                    setSyncNeeded={setSyncNeeded}
                  />
                  &nbsp;&nbsp;&nbsp;&nbsp;
                </>
              )}
              {permissions.edit_cameras && showBulkUpdating && (
                <ThemeProvider theme={theme}>
                  <Button
                    type="button"
                    color="primary"
                    onClick={openBulkUpdateDialog}
                    disabled={selected.length === 0}
                    sx={{ fontFamily: "Mulish" }}
                  >
                    Bulk Update
                  </Button>
                </ThemeProvider>
              )}
            </span>
          </div>
        )}

        {siteInfo.integration_type_name !== "autopatrol" && showBulkUpdating && (
          <BulkUpdateProductsDialog
            open={bulkUpdateDialogOpen}
            selectedCameras={selectedCameras}
            activeCameraProducts={activeCameraProducts}
            activeCameraProductsLoading={activeCameraProductsLoading}
            siteInfo={siteInfo}
            navigate={navigate}
            onClose={() => {
              setBulkUpdateDialogOpen(false);
            }}
            onApply={() => {
              setBulkUpdateDialogOpen(false);
            }}
          />
        )}

        <Table
          sx={{ minWidth: 1000, fontFamily: "Mulish" }}
          aria-label="simple table"
        >
          {/* <EnhancedTableHead
            onSelectAllClick={handleSelectAllClick}
            // rowCount={siteCameras.length}
          /> */}
          <EnhancedCameraTableHead
            onSelectAllClick={handleSelectAllClick}
            numSelected={selected.length}
            rowCount={siteCameras.results.length}
            onRequestSort={handleRequestSort}
            orderBy={orderBy}
            order={order}
            permissions={permissions}
            allExpanded={allExpanded}
            setAllExpanded={setAllExpanded}
            setExpandedObject={setExpandedObject}
            saveExpandedObjectAllTrue={saveExpandedObjectAllTrue}
            saveExpandedObjectAllFalse={saveExpandedObjectAllFalse}
            siteInfo={siteInfo}
          />
          <TableBody>
            {visibleRows.map((obj: any) => {
              // const srcImageString = `${obj.id}full`;
              const isItemSelected = isSelected(obj.id);
              return (
                <React.Fragment key={obj.id}>
                  <TableRow
                    role="checkbox"
                    aria-checked={isItemSelected}
                    tabIndex={-1}
                    selected={isItemSelected}
                  >
                    {permissions.edit_cameras &&
                      siteInfo.integration_type_name !== "autopatrol" && (
                        <TableCell padding="checkbox">
                          <Checkbox
                            color="primary"
                            checked={isItemSelected}
                            onClick={(event) =>
                              handleSingleCheckboxClick(event, obj.id)
                            }
                          />
                        </TableCell>
                      )}
                    <Tooltip
                      title={
                        <React.Fragment>
                          {srcImages[obj.id as keyof typeof srcImages]}
                        </React.Fragment>
                      }
                      placement="right-start"
                      sx={{ fontSize: "15px", fontFamily: "mulish" }}
                    >
                      <TableCell
                        sx={{ width: 300, fontFamily: "Mulish" }}
                        align="left"
                      >
                        <Link
                          to={`/sites/${siteInfo.id}/editcamera/${obj.id}`}
                          style={{
                            color: "#0d47a1",
                            textDecoration: "none",
                            cursor: "pointer",
                          }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.color = "#002171";
                            e.currentTarget.style.textDecoration = "underline";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.color = "#0d47a1";
                            e.currentTarget.style.textDecoration = "none";
                          }}
                        >
                          {obj.camera_name}
                        </Link>
                      </TableCell>
                    </Tooltip>
                    <TableCell align="left">
                      {obj.active ? checkedCircleIcon : cancelIconRed}
                    </TableCell>
                    {!hideUseMotion && (
                      <TableCell
                        align="left"
                        sx={{ fontFamily: "Mulish", width: 150 }}
                      >
                        {obj.use_motion ? obj.use_motion : nA}
                        <MotionOverrideMarker
                          override={obj.use_motion_override}
                        />
                      </TableCell>
                    )}
                    {!hideIgnoreZonesColumn && (
                      <TableCell
                        align="left"
                        sx={{ fontFamily: "Mulish", width: 180 }}
                      >
                        {obj.has_ignore_zones
                          ? checkedCircleIcon
                          : cancelIconRed}
                      </TableCell>
                    )}
                    {siteInfo.integration_type_name !== "ailink" &&
                    !autopatrolSite ? (
                      <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                        {obj.health_status === "healthy" && checkedCircleIcon}
                        {obj.health_status === "error" && (
                          <Tooltip
                            title={
                              obj.camera_health_comment
                                ? obj.camera_health_comment
                                : "Unable to connect to the camera or no frame since launch"
                            }
                            placement="top"
                            sx={{ fontSize: "24px", fontFamily: "mulish" }}
                          >
                            <CancelIcon color="error" />
                          </Tooltip>
                        )}
                        {(obj.health_status === "unknown" ||
                          obj.health_status === null) && (
                          <Tooltip
                            title={
                              obj.camera_health_comment
                                ? obj.camera_health_comment
                                : "Unable to determine the health status of this camera"
                            }
                            placement="top"
                            sx={{ fontSize: "24px", fontFamily: "mulish" }}
                          >
                            <WarningIcon sx={{ color: "#b4b4b4" }} />
                          </Tooltip>
                        )}
                        {obj.health_status === "warning" && (
                          <Tooltip
                            title={
                              obj.camera_health_comment
                                ? obj.camera_health_comment
                                : "Broken frames since launch or blurry view"
                            }
                            placement="top"
                            sx={{ fontSize: "15px", fontFamily: "mulish" }}
                          >
                            <ErrorIcon sx={{ color: "#F57C00" }} />
                          </Tooltip>
                        )}
                      </TableCell>
                    ) : (
                      !autopatrolSite && (
                        <TableCell align="left" sx={{ fontFamily: "Mulish" }}>
                          <Tooltip title="Health can not be measured on a camera on this type of site (AI Link)">
                            <WarningIcon sx={{ color: "#b4b4b4" }} />
                          </Tooltip>
                        </TableCell>
                      )
                    )}
                    {!autopatrolSite && (
                      <TableCell
                        align="left"
                        sx={{ fontFamily: "Mulish", width: 200 }}
                      >
                        {createOptimalSettingsIcon(srcImages, obj)}
                      </TableCell>
                    )}
                    <TableCell
                      align="right"
                      sx={{
                        position: "sticky",
                        right: 0,
                        backgroundColor: "white",
                        zIndex: 1,
                        fontFamily: "Mulish",
                        fontWeight: "Bold",
                        fontSize: "15px",
                        minWidth: 150,
                        paddingRight: "40px",
                      }}
                    >
                      <div className="flex items-center justify-end gap-2">
                        {/* Talk-down without an alert (ENG-2135): the control
                            gates itself (flag + permission + RTSP-family
                            site) and renders nothing otherwise. ENG-1721:
                            hidden when the camera reports no speaker
                            (talk_down_capable false; null/absent = shown). */}
                        <TalkDownButton
                          cameraId={obj.id}
                          cameraName={obj.camera_name ?? ""}
                          integrationTypeName={siteInfo.integration_type_name}
                          talkDownCapable={obj.talk_down_capable}
                        />
                        <IconButton
                          aria-label="expand row"
                          size="small"
                          onClick={() => {
                            saveExpandedObject(obj.id);
                          }}
                        >
                          <ThemeProvider theme={theme}>
                            {expandedObject[
                              obj.id as keyof typeof expandedObject
                            ] ? (
                              <Chip
                                icon={<KeyboardArrowUpIcon />}
                                label="Show Less"
                                color="secondary"
                                sx={{ fontFamily: "Mulish" }}
                              />
                            ) : (
                              <Chip
                                icon={<KeyboardArrowDownIcon />}
                                label="Show More"
                                color="secondary"
                                sx={{ fontFamily: "Mulish" }}
                              />
                            )}
                          </ThemeProvider>
                        </IconButton>
                      </div>
                    </TableCell>
                  </TableRow>
                  <CameraInfoRow
                    obj={obj}
                    expanded={
                      expandedObject[obj.id as keyof typeof expandedObject]
                    }
                    setBackdropLoadingScreenOn={setBackdropLoadingScreenOn}
                    siteInfo={siteInfo}
                    permissions={permissions}
                    srcImages={srcImages}
                  />
                </React.Fragment>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[5, 10, 25]}
        component="div"
        count={count}
        rowsPerPage={rowsPerPage}
        page={page}
        onPageChange={handleChangePage}
        onRowsPerPageChange={handleChangeRowsPerPage}
      />
    </Paper>
  );
};
